import { runtimeEnv } from "config/runtimeEnv";
import { setCurrentUser } from "utils/utils";
import { API_ENDPOINT } from "./Api";
import axios from "axios";
import { applyTenantHeader } from "./Request";

let env = runtimeEnv("B2B_API_BASE_URL")

const requestInstance = axios.create({
    baseURL: env,
    'Content-Type': 'application/json',
  });

requestInstance.interceptors.request.use(applyTenantHeader);

//Login Service
export const accountDeletionApi = async(user) => {
  const data = user || {};
  const res = await requestInstance.post(`${env}${API_ENDPOINT.userDeletion.api}`, data)
  .catch((err) =>  err.response)
  return setCurrentUser(res)
}